import { HtmlTextWrapper, IconImage } from '@/core/features';
import color from '@/core/features/styles/color';
import { bemModule } from '@/core/utils/bem-classname';

import styles from './info-text.module.scss';

type ColorType = 'blue' | 'green' | 'red' | 'yellow';

const bem = bemModule(styles);
export type InfoTextProps = {
    fontSize: string;
    fullWidth?: boolean;
    icon?: string;
    iconHeight: number;
    iconWidth: number;
    lineHeight?: string;
    marginTop?: boolean;
    padding: string;
    text?: string;
} & (
    | {
          backgroundColor: string;
          colorType?: never;
          textColor: string;
      }
    | {
          backgroundColor?: never;
          colorType: ColorType;
          textColor?: never;
      }
);

export default function InfoText({
    backgroundColor,
    colorType,
    fontSize,
    fullWidth,
    icon,
    iconHeight,
    iconWidth,
    lineHeight,
    marginTop,
    padding,
    text,
    textColor,
}: InfoTextProps) {
    return (
        <div
            className={`${bem(styles.infoContainer, { marginTop })} ${fullWidth ? 'full-width' : ''}`}
            style={{
                backgroundColor: backgroundColor ?? backgroundColors[colorType ?? 'fallback'],
                color: textColor ?? textColors[colorType ?? 'fallback'],
                padding,
            }}
        >
            {icon && (
                <div className={styles.iconWrapper}>
                    <IconImage
                        height={iconHeight}
                        url={icon}
                        width={iconWidth}
                    />
                </div>
            )}

            {text && (
                <div style={{ fontSize, lineHeight }}>
                    <HtmlTextWrapper htmlText={text} />
                </div>
            )}
        </div>
    );
}

const textColors: Record<'fallback' | ColorType, string> = {
    blue: color('check24Blue'),
    fallback: color('black'),
    green: color('moorMonster'),
    red: color('redBerry'),
    yellow: color('modeBeige'),
};

const backgroundColors: Record<'fallback' | ColorType, string> = {
    blue: color('foam'),
    fallback: color('gallery'),
    green: color('gardenShed'),
    red: color('petalBloom'),
    yellow: color('lemonTint'),
};
